import {InfluencerCampaign, InfluencerCampaignPost} from './influencer-campaign';
import {CampaignInfluencerStatus} from '../app/app.constants';
import { Gender } from './filter-search';

export class Campaign {
  id: number;
  name: string;
  type: string;
  typeName: string;
  numberOfInfluencers: number;
  numberOfPosts: number;
  reach: number;
  reachPercent: number;
  engagement: number;
  engagementPercent: number;
  impact: number;
  impactPercent: number;
  is_expanded: boolean | false;
  key_search: string;

  isFetchingKpi: boolean;
  // use for media platform
  influencers: InfluencerCampaign[] = [];
  // influencer platform
  posts: InfluencerCampaignPost[] = [];
  status: CampaignInfluencerStatus;
  campaignInfluencerId: number;
  campaignType: string;
  // newly published post count
  newPosts: number;
}

export class InfluencerAddCampaign {
  id: number;
  influencer_id: number;
  influencer_name: string;
  influencer_image: string;
  influencer_group_id: number;
  country: string;
  country_code: string;
  engagement: number;
  reach: number;
  impact: number;
  platform: string;
  company_id: number;
  stt: number;
  impression: number;
  is_new: boolean;
  profilePicture: string | null;
  domain: string | null;
  numberOfPosts: number | 0;
  numberOfFollowers: number | 0;
  description: string | null;
  selected: boolean;
  influencerChannels: any;
  action: string;
  profile_image: string;
  status: string;

  topMention: string;
  favoriteTopics: string;
  numOfPostThisMonth: number;
  previewed: boolean;

  // use for discover post
  relativepath: string;
  url_hash: string;
}

export class CampaignCustomTerm {
  id?: number;
  body: string;
  companyId: number;
  contractSeq?: number;
  hasParams?: boolean;
  campaignType: string;
  summary: string;
  heading?: string;
  isUsed?: boolean;
  systemWide?: boolean;
  required?: boolean;
}

export enum NewCampaignTabs {
  CAMPAIGN = 'campaign',
  CHAT = 'chat'
}

export enum ContactPermissionTabs {
  CONTACT_PERMISSION = 'contact permission',
  CONTACT = 'contact'
}

export enum CampaignPostStatus {
  NOT_ADDED = 'NOT-ADDED',
  ADDED = 'ADDED',
  REMOVED = 'REMOVED'
}

/**
 * Data structure of post request to delete post from campaign
 */
export class DeletePostCampaign {
  urlHash: string;
  channelId: number;
}

export class CampaignInfluencerSearch {
  countries: Array<number> = [];
  genders: Array<number> = [];
  platforms: Array<number> = [];
  searchString: string;
  reachFrom: number;
  reachTo: number;
  engagementFrom: number;
  engagementTo: number;
  impactFrom: number;
  impactTo: number;
  audienceFilters: Array<any> = [];
}



// WEBPACK FOOTER //
// ./src/models/campaign.ts